import { inject, Injectable } from '@angular/core';
import { Library, Loader } from '@googlemaps/js-api-loader';
import { NotificationsService } from 'app/shared/toast';
import { catchError, from, map, throwError } from 'rxjs';
import { GOOGLE_API_KEY } from './google.tokens';


@Injectable()
export class GoogleLoader {

    private apiKey = inject<string>(GOOGLE_API_KEY);

    private loader = new Loader({ apiKey: this.apiKey });

    private ns = inject(NotificationsService);

    loadStreetViewService() {
        return this.load('streetView').pipe(map(() => new google.maps.StreetViewService()));
    }

    loadRoute() {
        return this.load('routes').pipe(map(() => google.maps.routes.Route));
    }

    loadGeometry() {
        return this.load('geometry').pipe(map(() => google.maps.geometry));
    }

    loadElevationService() {
        return this.load('elevation').pipe(map(() => new google.maps.ElevationService()));
    }

    loadPlaces() {
        return this.load('places').pipe(map(() => google.maps.places));
    }

    loadMapsLibrary() {
        return this.load('maps');
    }

    private load(library: Library) {
        return from(this.loader.importLibrary(library)).pipe(catchError(e => {
            this.ns.warn('Google maps failed to load. Please reload the page.');
            return throwError(() => e);
        }));
    }
}
